import { PageLayoutDefaultErrorPageProps } from '@sis/react-library';
import sislogo from '../../assets/SIS_Logo.svg';
import { commonRoutes } from '../shared/commonConstants';

export const ErrorPageProps = (): PageLayoutDefaultErrorPageProps => {
    return {
        logoSrc: sislogo,
        projectTitle: "Racing Pricing Manager",
        homeUrl: commonRoutes.home
    }
}
